import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
    isCartOpen: false,
    cartItems: [],
};

const addCartItem = (cartItems, productToAdd) => {
    // Find if cartItems contains productToAdd
    const existingCartItem = cartItems.find( 
        (cartItem) => cartItem.id === productToAdd.id
    );

    //If found, increment quantity
    if (existingCartItem){
        return cartItems.map((cartItem) =>
            cartItem.id === productToAdd.id
                ? {...cartItem, quantity: cartItem.quantity + 1} 
                : cartItem
        );
    }  

    //return new array with modified cartItems and the new cart item
    return [...cartItems, { ...productToAdd, quantity: 1 }];
}

const removeCartItem = (cartItems, productToRemove) =>{
    //Check if cartItems contains product to remove
    const existingCartItem = cartItems.find(
        (cartItem) => cartItem.id === productToRemove.id
    );

    //Check if quantity is equal to 1, if it is then remove the item
    if (existingCartItem.quantity === 1){
        return cartItems.filter((cartItem) => cartItem.id !== productToRemove.id);
    }
    
    //Return a new array with modified cartItems
    return cartItems.map((cartItem) =>
        cartItem.id === productToRemove.id
        ? {...cartItem, quantity: cartItem.quantity - 1}
        : cartItem
        );
}

const clearCartItem = (cartItems, cartItemToClear) => 
    cartItems.filter((cartItem) => cartItem.id !== cartItemToClear.id
);

export const cartSlice = createSlice({
    name: 'cart',
    initialState: INITIAL_STATE,
    reducers: {
        setIsCartOpen: (state, action) => {
            state.isCartOpen = action.payload;
        },
        addItemToCart: (state, action) => {
            state.cartItems = addCartItem(state.cartItems, action.payload);
        },
        removeItemFromCart: (state, action) => {
            state.cartItems = removeCartItem(state.cartItems, action.payload);
        },
        clearItemFromCart: (state, action) => {
            state.cartItems = clearCartItem(state.cartItems, action.payload);
        },
    }
});

export const { setIsCartOpen, addItemToCart, removeItemFromCart, clearItemFromCart } = cartSlice.actions;

export const cartReducer = cartSlice.reducer;

/* import { CART_ACTION_TYPES } from "./cart.types";

export const cartReducer = (state = INITIAL_STATE, action) => {
    console.log('Dispatched Cart Reducer');
    console.log(action);
    const { type, payload } = action;

    switch(type) {
        case CART_ACTION_TYPES.SET_IS_CART_OPEN:
            return {
                ...state,
                isCartOpen: payload
            };
        case CART_ACTION_TYPES.SET_CART_ITEMS:
            return {
                ...state,
                cartItems: payload
            };
        default:
            return state;
    }
}; */